import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "color-container" }
const _hoisted_2 = { class: "color-wrapper" }
const _hoisted_3 = { class: "selected" }
const _hoisted_4 = { class: "selected-slider" }
const _hoisted_5 = { class: "selected-slider-count" }
const _hoisted_6 = {
  key: 0,
  class: "template-name"
}
const _hoisted_7 = { class: "color-picker-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "undo"
}
const _hoisted_9 = {
  key: 0,
  class: "btn"
}
const _hoisted_10 = { class: "color-picker-inner" }
const _hoisted_11 = {
  key: 1,
  class: "color-picker-actions"
}
const _hoisted_12 = {
  key: 0,
  class: "btn"
}
const _hoisted_13 = {
  key: 1,
  class: "btn"
}
const _hoisted_14 = {
  key: 2,
  class: "color-picker-actions"
}
const _hoisted_15 = {
  key: 0,
  class: "btn"
}
const _hoisted_16 = { class: "btn" }
const _hoisted_17 = { class: "editor" }
const _hoisted_18 = {
  key: 0,
  class: "btn"
}
const _hoisted_19 = {
  key: 1,
  class: "btn"
}
const _hoisted_20 = {
  key: 2,
  class: "btn"
}
const _hoisted_21 = {
  key: 3,
  class: "btn"
}
const _hoisted_22 = {
  key: 4,
  class: "btn"
}
const _hoisted_23 = {
  key: 5,
  class: "btn"
}
const _hoisted_24 = {
  key: 6,
  class: "btn"
}
const _hoisted_25 = {
  key: 7,
  class: "checkbox"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_slider = _resolveComponent("app-slider")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_color_picker = _resolveComponent("app-color-picker")!
  const _component_app_editor_canvas = _resolveComponent("app-editor-canvas")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('numberOfSegments')) + ": " + _toDisplayString(_ctx.slider), 1),
          (_ctx.templateRef?.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.t('template')) + ": " + _toDisplayString(_ctx.templateRef?.name), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_app_slider, {
            modelValue: _ctx.slider,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slider) = $event)),
            min: 1,
            max: 12
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.templateRef?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_app_button, {
                        raised: "",
                        severity: "secondary",
                        icon: ['fas', 'undo'],
                        onClick: _ctx.cancelledTemplate
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_app_color_picker, {
              "is-preview-row": false,
              "is-combos-section": false,
              "is-info": false,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.colorChange($event)))
            })
          ]),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                (_ctx.templateRef?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_app_button, {
                        raised: "",
                        icon: ['fas', 'undo'],
                        severity: "secondary",
                        title: "resetTemplate",
                        onClick: _ctx.cancelledTemplate
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isChangeTemplate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_app_button, {
                        raised: "",
                        icon: ['fas', 'save'],
                        severity: "secondary",
                        title: "saveChanges",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCreateTemplateModal('update')))
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                (!_ctx.isChangeTemplate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_app_button, {
                        raised: "",
                        severity: "secondary",
                        icon: ['fas', 'save'],
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCreateTemplateModal('update')))
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_app_button, {
                    raised: "",
                    severity: "secondary",
                    icon: ['fas', 'plus'],
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCreateTemplateModal('create')))
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_17, [
        _createVNode(_component_app_editor_canvas, {
          ref: "editorCanvasRef",
          "image-url": _ctx.imageUrl,
          "onUpdate:imageUrl": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.imageUrl) = $event)),
          segments: _ctx.frameColors,
          "gap-between-segments": _ctx.gapBetweenSegments,
          "is-mark-segment": true,
          onSelectedSegment: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedSegment($event)))
        }, null, 8, ["image-url", "segments", "gap-between-segments"])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["buttons", { isMobile: _ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_app_button, {
                raised: "",
                severity: "secondary",
                title: "addTemplate",
                icon: ['fas', 'plus'],
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openCreateTemplateModal('create')))
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_app_button, {
                raised: "",
                severity: "secondary",
                title: "myTemplates",
                icon: ['fas', 'fill-drip'],
                onClick: _ctx.openPaletteTemplatesModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_app_button, {
                raised: "",
                title: "pickPhoto",
                severity: "secondary",
                icon: ['fas', 'sliders'],
                onClick: _ctx.openImageSettingsModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_app_button, {
                raised: "",
                icon: ['fas', 'camera'],
                severity: "secondary",
                title: "takePhoto",
                onClick: _ctx.openCameraModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_app_button, {
                severity: "success",
                title: "download",
                onClick: _ctx.saveToDevice
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_app_button, {
                severity: "warning",
                title: "saveToGallery",
                loading: _ctx.isSaveToGallery,
                onClick: _ctx.saveToGallery
              }, null, 8, ["loading", "onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_app_button, {
                severity: "info",
                title: "addSign",
                onClick: _ctx.openImageModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_AppCheckbox, {
                modelValue: _ctx.rememberChoose,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rememberChoose) = $event)),
                label: "rememberChoose"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 8,
              icon: ['fas', 'ellipsis-h'],
              size: "xl",
              onClick: _withModifiers(_ctx.openPopover, ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_app_popover, {
      visible: _ctx.visiblePopover,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visiblePopover) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.openPaletteTemplatesModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'fill-drip']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('myTemplates')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageSettingsModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'sliders']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('pickPhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openCameraModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'camera']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('takePhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToDevice }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'download']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('download')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToGallery }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'images']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('saveToGallery')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'fa-pencil-square']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('addSign')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.rememberChoose,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rememberChoose) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('rememberChoose')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}